import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import zihuaLogo from "../../../assets/pdfs/zihua-logo.png";
import header from "../../../assets/pdfs/Mask group.png";
import gradient from "../../../assets/pdfs/background2.png";
import { format } from "date-fns";
// Estilos
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
  },
  sectionHeader: {
    height: "15%",
    justifyContent: "center",
    alignItems: "center",
  },
  sectionFooter: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "8%",
    justifyContent: "center",
    alignItems: "center",
  },
  headerBackground: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
  logo: {
    position: "absolute",
    width: "100px",
    height: "100px",
  },
  content: {
    marginTop: 10,
    marginVertical: 20,
  },
  textFooter: {
    color: "white",
    marginVertical: 5,
  },
  signatureLine: {
    width: "86.5%",
    height: 1,
    backgroundColor: "black",
    marginBottom: 5,
  },
});

// Datos de ejemplo
const transactions = [
  { date: "01/01/2025", description: "Pago inicial", amount: 10000.0 },
  { date: "15/01/2025", description: "Abono mensual", amount: 416708.33 },
  { date: "15/02/2025", description: "Abono mensual", amount: 416708.33 },
  { date: "15/03/2025", description: "Abono mensual", amount: 416708.33 },
];

const monthNames = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];
const AccountStatement = (props) => {
  const paidCount = props.payment.filter(
    (payment) => payment.status === "PAID"
  ).length;
  const totalPaid = props.payment
    .filter((payment) => payment.status === "PAID")
    .reduce((sum, payment) => sum + payment.amount, 0);
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.sectionHeader}>
          <Image src={gradient} style={styles.headerBackground} />
          <Image src={header} style={styles.headerBackground} />
          <Image src={zihuaLogo} style={styles.logo} />
        </View>
        <View style={styles.content}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              marginHorizontal: 40,
            }}
          >
            <View style={{ flexDirection: "column" }}>
              <View style={{ flexDirection: "row", paddingVertical: 5 }}>
                <Text style={{ fontSize: 12 }}>Cliente: </Text>
                <Text style={{ fontSize: 10, marginLeft: 5 }}>
                  {props.fullName}
                </Text>
              </View>
              <View style={{ flexDirection: "row", paddingVertical: 5 }}>
                <Text style={{ fontSize: 12 }}>Fecha: </Text>
                <Text style={{ fontSize: 10, marginLeft: 5 }}>
                  {format(new Date(), "dd/MM/yyyy")}
                </Text>
              </View>
              <View style={{ flexDirection: "row", paddingVertical: 5 }}>
                <Text style={{ fontSize: 12 }}>Terreno: </Text>
                <Text style={{ fontSize: 10, marginLeft: 5 }}>
                  {props.payment[0].landName}
                </Text>
              </View>
            </View>
            <View style={{ alignItems: "flex-end" }}>
              <Text style={{ fontSize: 12 }}>ZIHUA INVESTMENTS</Text>

              <View
                style={{
                  flexDirection: "column",
                  paddingVertical: 5,
                  alignItems: "flex-end",
                }}
              >
                <Text style={{ fontSize: 10, marginLeft: 5 }}>
                  calle 13 # 10 - 32
                </Text>
                <Text style={{ fontSize: 10, marginLeft: 5 }}>3118428832</Text>
                <Text style={{ fontSize: 10, marginLeft: 5 }}>
                  info@zihuainvest.com
                </Text>
              </View>
            </View>
          </View>

          <View style={{ height: "20px", marginTop: 20 }}>
            <Image src={gradient} style={styles.headerBackground} />
            <View
              style={{
                width: "100%",
                flexDirection: "row",
                position: "absolute",
                justifyContent: "space-between",
                color: "white",
                marginHorizontal: 40,
              }}
            >
              <Text style={{ fontSize: 12 }}>Estado de Cuenta</Text>
              <Text style={{ fontSize: 12, marginHorizontal: 80 }}>
                Pagos generados a la fecha
              </Text>
            </View>
          </View>

          <View style={{ marginHorizontal: 40, marginTop: 20 }}>
            {props.payment.map((month, index) => {
              const monthName = month?.period
                ? monthNames[(month.period - 1) % 12]
                : "Desconocido";

              return (
                <View
                  key={index}
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 10,
                  }}
                >
                  <Text style={{ fontSize: 12 }}>{monthName}</Text>
                  <View
                    style={{
                      flexDirection: "row",
                      width: "20%",
                      justifyContent: "space-between",
                    }}
                  >
                    <Text style={{ fontSize: 8 }}>
                      {month?.status === "PENDING" ? "Pendiente" : "Pagado"}
                    </Text>
                    <Text style={{ fontSize: 8 }}>{month?.amount}</Text>
                  </View>
                </View>
              );
            })}
          </View>

          <View
            style={[
              styles.signatureLine,
              { marginHorizontal: 40, marginTop: 20 },
            ]}
          />

          <View
            style={{
              flexDirection: "column",
              alignItems: "flex-end",
              marginHorizontal: 40,
            }}
          >
            <View style={{ flexDirection: "row", paddingVertical: 5 }}>
              <Text style={{ fontSize: 12 }}>Pagos Completados: </Text>
              <Text
                style={{ fontSize: 10, marginLeft: 5, alignItems: "center" }}
              >
                {paidCount}
              </Text>
            </View>
            <View style={{ flexDirection: "row", paddingVertical: 5 }}>
              <Text style={{ fontSize: 12 }}>Total Pagado: </Text>
              <Text style={{ fontSize: 10, marginLeft: 5 }}>
              ${totalPaid.toFixed(2)}
              </Text>
            </View>
            <View style={{ flexDirection: "row", paddingVertical: 5 }}>
              <Text style={{ fontSize: 12 }}>Valor deuda: </Text>
              <Text style={{ fontSize: 10, marginLeft: 5 }}>
                ${props.payment[11].landPrice}
              </Text>
            </View>
            <View style={[styles.signatureLine, { width: "40%" }]} />

            <View style={{ flexDirection: "column", alignItems: "flex-end" }}>
              <Text style={{ fontSize: 12 }}>{props.payment[11].balance}</Text>
            </View>
          </View>
        </View>

        <View style={styles.sectionFooter}>
          <Image src={gradient} style={styles.headerBackground} />
          <Text style={styles.textFooter}>zihuainvest.com</Text>
          <Text style={styles.textFooter}>info@zihuainvest.com</Text>
        </View>
      </Page>
    </Document>
  );
};

export default AccountStatement;
